import React from 'react';

// Import team images (update paths based on your actual images)
import vrushaliImage from '../../assets/images/Vrushali Waghmare.jpg';
import girishImage from '../../assets/images/Girish Ranmale - Chief Technology Officer.jpg';
import ameyImage from '../../assets/images/Amey Kothari - CEO.jpg';

const teamMembers = [
  {
    id: 1,
    name: 'Amey Kothari',
    position: 'Chief Executive Officer',
    description: 'Visionary leader behind Infinity Enterprises, driving strategic planning, business development, and overall leadership. Extensive experience guides the company towards becoming a global leader.',
    image: ameyImage,
  },
  {
    id: 2,
    name: 'Girish Ranmale',
    position: 'Chief Technology Officer',
    description: 'Leads technological innovation with focus on sustainable solutions. Responsible for developing and implementing cutting-edge technologies that optimize logistics and shipping operations.',
    image: girishImage,
  },
  {
    id: 3,
    name: 'Vrushali Waghmare',
    position: 'Head of Accounts',
    description: 'Expert in optimizing operational processes and ensuring efficiency across all logistics functions. With a keen eye for process design and team management, she drives operational excellence at Infinity Enterprises.',
    image: vrushaliImage,
  }
];

const OurTeam = () => {
  return (
    <section className="section-y bg-white">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-16">
          <p className="section-kicker">Leadership</p>
          <h2 className="section-title">Our Team</h2>
          <p className="section-subtitle">
            Meet the experienced professionals driving excellence at Infinity Enterprises
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className="card-surface bg-lightGray/70 overflow-hidden border-lightGray group flex flex-col"
            >
              {/* Image */}
              <div className="aspect-[4/4] overflow-hidden bg-gradient-to-br from-navy/20 to-teal/20">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              {/* Content */}
              <div className="p-6 lg:p-7 text-center flex flex-col flex-grow">
                <h3 className="text-lg font-bold text-navy mb-1 tracking-tight">
                  {member.name}
                </h3>
                <p className="text-teal font-semibold text-sm mb-3">
                  {member.position}
                </p>
                <p className="text-darkGray/70 leading-relaxed text-sm">
                  {member.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;